import React from "react";
import { List, Divider, Card, Typography } from "@mui/material";
import TransactionItem from "./TransactionItem";
import {
  convertDateToFormattedString,
  groupAndSortByDate,
} from "../../common/helpers";
import { Transaction } from "../../pages/Card/models";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";

interface TransactionsListProps {
  transactions: Transaction[];
}

const TransactionsList: React.FC<TransactionsListProps> = ({
  transactions,
}) => {
  const { t } = useTranslation();

  const getStatusIcon = (type: "Credit" | "Debit") => {
    const lowerCaseType = type.toLowerCase();
    switch (lowerCaseType) {
      case "credit":
        return <NorthEastIcon color="success" />;
      case "debit":
        return <SouthEastIcon color="error" />;
      default:
        return <InfoIcon color="action" />;
    }
  };

  const groupedTransactions = groupAndSortByDate(transactions, "created_at");

  // Workaround:Backend returns positive amount for credit and debit
  function getAmount(transaction: Transaction) {
    if (transaction.type === "Credit") {
      return transaction.amount;
    }
    return transaction.amount > 0 ? -transaction.amount : transaction.amount;
  }

  function getTransactionTitleByType(transaction: Transaction) {
    const type = transaction.type.toLowerCase();
    if (type === "credit") {
      return t("debit_transaction");
    } else if (type === "debit") {
      return t("deposit_received");
    }
    return t("transaction");
  }

  return (
    <Card variant="outlined" sx={{ border: "none" }}>
      <List disablePadding>
        {Object.keys(groupedTransactions).map((date) => (
          <React.Fragment key={date}>
            <Typography
              variant="subtitle2"
              fontWeight="600"
              color="text.secondary"
              sx={{ ml: 2, mt: 2 }}
            >
              {date}
            </Typography>
            {groupedTransactions[date].map((transaction, index) => (
              <React.Fragment key={transaction.reference_id}>
                {index !== 0 && <Divider sx={{ ml: 6 }} />}

                <TransactionItem
                  key={transaction.reference_id}
                  title={
                    transaction.merchant_name ??
                    getTransactionTitleByType(transaction)
                  }
                  icon={getStatusIcon(transaction.type)}
                  description={[transaction.description]}
                  amount={getAmount(transaction)}
                  // linkTo={`/card-transaction/${transaction.reference_id}`}
                />
              </React.Fragment>
            ))}
          </React.Fragment>
        ))}
      </List>
    </Card>
  );
};

export default TransactionsList;
